export default "__VITE_ASSET__Bu_Ag4KA__"